document.addEventListener('alpine:init', () => {
  Alpine.data('CardsCarousel', () => ({
    $section: null,
    $swiper: null,
    swiper: null,
    init() {
      let am = this;

      document.addEventListener('init:CardsCarousel', (e) => {
        let $target = e.target;
        am.$section = $target;
        am.$swiper = $target.querySelector('.section-cards');
        am.InitCarousel();
      });
    },
    InitCarousel() {
      let am = this;
      var swiper = new Swiper(am.$swiper, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        breakpoints: {
          710: {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: false
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 40,
            loop: false
          }
        },
        navigation: {
          nextEl: am.$section.querySelector('.swiper-button-next'),
          prevEl: am.$section.querySelector('.swiper-button-prev')
        },
      });
      am.swiper = swiper;
    }
  }));
});
